<div class="w-100" *ngIf="getPermission('UsersGrid_serviceUsersTab')?.visible || getPermission('UsersGrid_salesUsersTab')?.visible">
  <app-loader *ngIf="!showGrid"></app-loader>
<div class="border p-2 pt-3">
  <div class="row mb-2">
    <div class="col">
      <div class="tabbable-line border-bottom">
        <ul class="nav nav-tabs">
          @if (getPermission('UsersGrid_serviceUsersTab')?.visible) {
            <li class="nav-item">
              <a class="nav-link" [ngClass]="{'active': selectedTab === 'service' && getPermission('UsersGrid_serviceUsersTab')?.visible}" (click)="tabClick('service')"
              data-bs-toggle="selectedTab">Service</a>
            </li>
          }
          @if (getPermission('UsersGrid_salesUsersTab')?.visible) {
            <li class="nav-item">
              <a class="nav-link" [ngClass]="{'active': selectedTab === 'sales' && getPermission('UsersGrid_salesUsersTab')?.visible}"
                (click)="tabClick('sales')" data-bs-toggle="selectedTab">Sales</a>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
</div>
  @if (showGrid && selectedTab == 'service' && getPermission('UsersGrid_serviceUsersTab')?.visible) {
    <ejs-grid
        #usersGrid
        *ngIf="showGrid"
        [id]="serviceGridName"
        [dataSource]="userProfiles"
        [height]="gridHeight"
        [allowPaging]="false" [enableInfiniteScrolling]="true" [enableVirtualization]="false" [enableVirtualMaskRow]="false" [infiniteScrollSettings]="infiniteScrollSettings"
        [pageSettings]="pageSettings"
        [gridLines]="false"
        [allowFiltering]="true"
        [allowSorting]="true"
        [enableHover]="false"
        [allowResizing]="true"
        [allowReordering]="true"
        [showColumnChooser]="true"
        [allowExcelExport]="true"
        [allowSelection]="true"
        [editSettings]="{ allowEditing: false }"
        [enablePersistence]="true"
        [filterSettings]="{ type: 'Menu' }"
        [selectionSettings]="{ mode: 'Both', checkboxOnly: true }"
        [query]="query"
        [searchSettings]='serviceSearchSettings'
        (rowDataBound)="onRowDataBound($event)"
        (commandClick)="onCommandClick($event)"
        (actionBegin)="onGridActionBegin($event)"
        (actionComplete)="onGridActionComplete($event, usersGrid)"
        (toolbarClick)="onToolbarClick($event)"
        (dataBound)="onDataBound($event)" (created)="onGridCreated($event)"
        (excelQueryCellInfo)="onExcelQueryCellInfo($event)"
        >
        <e-columns>
            <e-column
                *ngFor="let column of serviceColumns;"
                [isPrimaryKey]="column.isPrimaryKey || false"
                [field]="column.field"
                [headerText]="column.headerText"
                [clipMode]="column.field === 'Actions' ? '' : 'EllipsisWithTooltip'"
                [type]="column.type"
                [width]="column.width"
                [filter]="column.filter ? column.filter : { type: 'Menu' }"
                [format]="column.format ? column.format : null"
                [textAlign]="column.textAlign"
                [showInColumnChooser]="column.showInColumnChooser ?? true"
                [visible]="column.visible"
                [commands]="column?.commands ? column.commands : null"
                [edit]="column.edit"
                [allowReordering]="column.allowReordering ?? true"
                [freeze]="column.freeze ? column.freeze: null"
                [allowEditing]="column.allowEditing"
                [allowSorting]="column.allowSorting"
                [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">

                @if (column.field === UPGeneralFields.name) {
                  <ng-template  #template let-data>
                      <a href="javascript:" (click)="onUserClick(data)">{{data[UPGeneralFields.name]}}</a>
                  </ng-template>
                }
                @if (column.field === UPGeneralFields.userId) {
                  <ng-template #template let-data>
                      <a href="javascript:" (click)="onUserClick(data)">{{data[UPGeneralFields.userId]}}</a>
                  </ng-template>
                }
              @if (column?.field === 'status') {
                <ng-template #template let-data>
                  <span class="grid-status-column" [ngStyle]="{'background-color': $safeNavigationMigration(data?.statusColor)}">
                    {{data.status}}
                  </span>
                </ng-template>
                }
            </e-column>
        </e-columns>
    </ejs-grid>
<div class="grid-footer d-flex" style="justify-content:flex-end; margin-right: 20px; padding:8px 12px; border-top:1px solid #eee;">
    <div class="grid-total-count" style="font-weight:600;">
        Total Records: {{totalRecords | number}}
    </div>
</div>

  }  @else if (showGrid && selectedTab == 'sales' && getPermission('UsersGrid_salesUsersTab')?.visible) {
    <ejs-grid
        #usersGrid
        *ngIf="showGrid"
        [id]="salesGridName"
        [dataSource]="userProfiles"
        [height]="gridHeight"
        [allowPaging]="false" [enableInfiniteScrolling]="true" [enableVirtualization]="false" [enableVirtualMaskRow]="false" [infiniteScrollSettings]="infiniteScrollSettings"
        [pageSettings]="pageSettings"
        [gridLines]="false"
        [allowFiltering]="true"
        [allowSorting]="true"
        [enableHover]="false"
        [allowResizing]="true"
        [allowReordering]="true"
        [showColumnChooser]="true"
        [allowExcelExport]="true"
        [allowSelection]="true"
        [editSettings]="{ allowEditing: false }"
        [enablePersistence]="true"
        [filterSettings]="{ type: 'Menu' }"
        [selectionSettings]="{ mode: 'Both', checkboxOnly: true }"
        [query]="query"
        [searchSettings]='salesSearchSettings'
        (rowDataBound)="onRowDataBound($event)"
        (commandClick)="onCommandClick($event)"
        (actionBegin)="onGridActionBegin($event)"
        (actionComplete)="onGridActionComplete($event, usersGrid)"
        (toolbarClick)="onToolbarClick($event)"
        (dataBound)="onDataBound($event)" (created)="onGridCreated($event)"
        (excelQueryCellInfo)="onExcelQueryCellInfo($event)"
        >
        <e-columns>
            <e-column
                *ngFor="let column of salesColumns;"
                [isPrimaryKey]="column.isPrimaryKey || false"
                [field]="column.field"
                [headerText]="column.headerText"
                [clipMode]="column.field === 'Actions' ? '' : 'EllipsisWithTooltip'"
                [type]="column.type"
                [width]="column.width"
                [filter]="column.filter ? column.filter : { type: 'Menu' }"
                [format]="column.format ? column.format : null"
                [textAlign]="column.textAlign"
                [showInColumnChooser]="column.showInColumnChooser ?? true"
                [visible]="column.visible"
                [commands]="column?.commands ? column.commands : null"
                [edit]="column.edit"
                [allowReordering]="column.allowReordering ?? true"
                [freeze]="column.freeze ? column.freeze: null"
                [allowEditing]="column.allowEditing"
                [allowSorting]="column.allowSorting"
                [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">

                @if (column.field === UPGeneralFields.name) {
                  <ng-template  #template let-data>
                      <a href="javascript:" (click)="onUserClick(data)">{{data[UPGeneralFields.name]}}</a>
                  </ng-template>
                }
                @if (column.field === 'territory') {
                  <ng-template  #template let-data>
                    <i class="fas fa-diagram-project green" *ngIf="data.secondaryTerritories" [title]="'Secondary Territories:' + data.secondaryTerritories  "></i>  {{data.territory}}
                  </ng-template>
                }
                @if (column.field === 'district') {
                  <ng-template  #template let-data>
                    <i class="fas fa-diagram-project green" *ngIf="data.secondaryDistricts" [title]="'Secondary Districts:' + data.secondaryDistricts  "></i>  {{data.district}}
                  </ng-template>
                }
                @if (column.field === 'region') {
                  <ng-template  #template let-data>
                    <i class="fas fa-diagram-project green" *ngIf="data.secondaryRegions" [title]="'Secondary Regions:' + data.secondaryRegions "></i>  {{data.region}}
                  </ng-template>
                }
                @if (column.field === UPGeneralFields.userId) {
                  <ng-template #template let-data>
                      <a href="javascript:" (click)="onUserClick(data)">{{data[UPGeneralFields.userId]}}</a>
                  </ng-template>
                }
              @if (column?.field === 'status') {
                <ng-template #template let-data>
                  <span class="grid-status-column" [ngStyle]="{'background-color': $safeNavigationMigration(data?.statusColor)}">
                    {{data.status}}
                  </span>
                </ng-template>
                }
            </e-column>
        </e-columns>
    </ejs-grid>
<div class="grid-footer d-flex" style="justify-content:flex-end; margin-right: 20px; padding:8px 12px; border-top:1px solid #eee;">
    <div class="grid-total-count" style="font-weight:600;">
        Total Records: {{totalRecords | number}}
    </div>
</div>

  }
</div>

@if ( showUserProfilePopup ) {
  <app-user-profile-popup
  [userProfile]="userProfile"
  (closePopup)="onClosePopup($event)"
  ></app-user-profile-popup>
}

<ng-template #columnChooser>
  <app-column-chooser
     [grid]="usersGrid"
  ></app-column-chooser>
</ng-template>

